import { rains } from "./weather";
import { addItem } from "./inventory";
import { taintAt } from "./reactions";
import { Tile, type Crop, type WorldState, idx } from "./types";

export function tickCrops(w: WorldState, dt: number): void {
  const wet = rains(w.weather);
  for (const c of w.overworld.crops) {
    if (wet) c.water = Math.min(1, c.water + dt * 0.15);
    else c.water = Math.max(0, c.water - dt * 0.012);
    const taint = taintAt(w, c.x, c.y);
    if (taint > 0) c.contamination = Math.min(1, c.contamination + taint * dt);
    if (w.weather === "storm") {
      c.stage = Math.max(0, c.stage - dt * 0.01);
      if (c.contamination > 0) c.contamination = Math.min(1, c.contamination + dt * 0.02);
    }
    const seasonMul = w.season === "ashfall" ? 0.45 : w.season === "highsun" ? 1.15 : 1;
    if (c.water > 0.15 && c.stage < 3 && w.weather !== "storm") {
      c.stage += dt * 0.018 * seasonMul * (0.5 + c.water);
    }
    if (c.contamination > 0.4) c.kind = "strange";
    const grown = c.stage >= 1 ? Tile.Crop : Tile.Soil;
    w.overworld.tiles[idx(c.x, c.y, w.overworld.w)] = grown;
  }
}

export function plantAt(w: WorldState, x: number, y: number, kind: Crop["kind"]): boolean {
  const tx = x | 0;
  const ty = y | 0;
  if (w.overworld.crops.some((c) => c.x === tx && c.y === ty)) return false;
  w.overworld.crops.push({
    x: tx,
    y: ty,
    kind,
    stage: 0,
    water: 0.4,
    contamination: 0,
    plantedAt: w.timeSec,
  });
  w.overworld.tiles[idx(tx, ty, w.overworld.w)] = Tile.Soil;
  return true;
}

export function harvestAt(w: WorldState, x: number, y: number): boolean {
  const i = w.overworld.crops.findIndex((c) => c.x === (x | 0) && c.y === (y | 0) && c.stage >= 3);
  if (i < 0) return false;
  const c = w.overworld.crops[i]!;
  w.overworld.crops.splice(i, 1);
  w.overworld.tiles[idx(c.x, c.y, w.overworld.w)] = Tile.Soil;
  if (c.kind === "strange") addItem(w.bag, { id: "strange_root", n: 1 });
  else addItem(w.bag, { id: "ration", n: 1 });
  return true;
}
